import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API });

export const createSession = (host_name, currency, revolut_link = "", payment_note = "") =>
  http.post(`/sessions`, { host_name, currency, revolut_link, payment_note }).then((r) => r.data);

export const getSession = (code) =>
  http.get(`/sessions/${code}`).then((r) => r.data);

export const uploadReceipt = (code, image_base64) =>
  http.post(`/sessions/${code}/receipt`, { image_base64 }).then((r) => r.data);

export const loadDemo = (code) =>
  http.post(`/sessions/${code}/demo`).then((r) => r.data);

export const updateReceiptData = (code, data) =>
  http.put(`/sessions/${code}/receipt-data`, data).then((r) => r.data);

export const shareSession = (code) =>
  http.post(`/sessions/${code}/share`).then((r) => r.data);

export const updatePaymentInfo = (code, revolut_link, payment_note = "") =>
  http.put(`/sessions/${code}/payment-info`, { revolut_link, payment_note }).then((r) => r.data);

export const joinSession = (code, name) =>
  http.post(`/sessions/${code}/guests`, { name }).then((r) => r.data);

export const updateSelections = (code, guestId, selections) =>
  http.put(`/sessions/${code}/guests/${guestId}/selections`, { selections }).then((r) => r.data);

export const updatePayment = (code, guestId, paid, payment_method) =>
  http.put(`/sessions/${code}/guests/${guestId}/payment`, { paid, payment_method }).then((r) => r.data);

export const getSummary = (code) =>
  http.get(`/sessions/${code}/summary`).then((r) => r.data);
